import { createAsyncThunk } from '@reduxjs/toolkit';
import { nanoid } from 'nanoid';
import createUploadSession from './createUploadSession';
import uploadAsset from './uploadAsset';

export default createAsyncThunk('mediaUpload/uploadAssets', async ({ files, channelToken, trigger }, { dispatch }) => {
  await Promise.all(
    Object.values(files).map(async (file) => {
      const { sessionHash } = await dispatch(
        createUploadSession({
          id: nanoid(),
          file,
          channelToken,
          trigger,
        })
      ).unwrap();

      return dispatch(
        uploadAsset({
          file,
          trigger,
          sessionHash,
        })
      );
    })
  );
});
